import { AutoComplete } from '@nineeng/form-components';
import React from 'react';

interface Option {
	id: string;
	inputValue?: string;
	name?: string;
}

interface Target {
	value: (string | Option)[];
	[key: string]: any;
}

interface Props {
	onChange: (event: { target: Target }) => void;
	toLowerCase?: boolean;
	[key: string]: any;
}

const MultiFreeInput = ({ onChange, toLowerCase, ...props }: Props) => {
	const handleChange = ({ target }: { target: Target }) => {
		const value = (target.value || [])
			.map((v) => {
				if (typeof v === 'string') {
					return v.trim();
				} else {
					return v.id?.trim();
				}
			})
			.map((v) => (toLowerCase ? v?.toLowerCase() : v));
		onChange({ target: { ...target, value } });
	};

	return (
		<AutoComplete
			{...props}
			multiple
			options={[]}
			freeSolo
			handleHomeEndKeys
			onChange={handleChange}
			getOptionLabel={(option: string | Option) => {
				// handle enter key
				if (typeof option === 'string') {
					return option;
				}
				return option?.id;
			}}
			renderOption={(renderProps: React.HTMLAttributes<HTMLLIElement>, option: Option) => {
				return <li {...renderProps}>{option?.name}</li>;
			}}
			filterOptions={(options: Option[], params: { inputValue: string }) => {
				const filtered = [...options];
				const { inputValue } = params;

				if (inputValue) {
					filtered.push({
						id: inputValue,
						inputValue,
						name: `Add "${inputValue}"`,
					});
				}

				return filtered;
			}}
		/>
	);
};

export default MultiFreeInput;
